// Búsqueda de clientes del selector del Estado de cuenta, aparte para poder probarla.

const normalizar = (texto) =>
  (texto || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toUpperCase();

// Más opciones no se pueden recorrer a ojo; la lista avisa que hay que escribir más.
export const MAX_OPCIONES = 50;

// Cada palabra escrita debe aparecer en el nombre, en cualquier orden y sin importar tildes:
// "wendy santelis" encuentra a WENDY YAHOSKA SANTELIS CANALES. Devuelve todas las coincidencias.
export const buscarClientes = (clientes, escrito) => {
  const palabras = normalizar(escrito).split(/\s+/).filter(Boolean);
  if (palabras.length === 0) return clientes;
  return clientes.filter((cliente) => {
    const nombre = normalizar(cliente.fullName);
    return palabras.every((palabra) => nombre.includes(palabra));
  });
};

// Las opciones que muestra la lista: las primeras MAX_OPCIONES coincidencias.
export const filtrarClientes = (clientes, escrito) =>
  buscarClientes(clientes, escrito).slice(0, MAX_OPCIONES);
